import React, { useState, useEffect } from "react";
import InvestForm from "./InvestForm";
import coinGecko from "../../assets/js/coinGecko";
import "./css/InvestHere.css";

const InvestHere = (props) => {
    const [active, setActive] = useState("FIAT")
    const [outputRef] = useState(React.createRef())
    const [inputRef] = useState(React.createRef())
    const [input, setInput] = useState("0")
    const [trxPrice, setTRXPrice] = useState([])
    const [currency, setCurrency] = useState(props.currency)

    useEffect(() => {
        const fetchPriceDetails = async () => {
            let trxPriceData;
            if (currency === 'inr') {
                trxPriceData = await coinGecko.get("/coins/markets", {
                    params: {
                        vs_currency: "inr",
                        ids: "tron"
                    }
                })
            } else {
                trxPriceData = await coinGecko.get("/coins/markets", {
                    params: {
                        vs_currency: "usd",
                        ids: "tron"
                    }
                })
            }

            setTRXPrice(trxPriceData.data[0].current_price)
        }

        resetInput()
        fetchPriceDetails()
        checkUpdate()


    }, [currency])

    const resetInput = () => {
        inputRef.current.value = "";
        outputRef.current.value = "";
    }

    const checkUpdate = () => {
        setInterval(() => {
            if (window.localStorage.getItem('CurrentCurrency')) {
                setCurrency(window.localStorage.getItem('CurrentCurrency'));
            }
        }, 1000)
    }

    const setTRX = () => {
        setActive("TRX")
        outputRef.current.value = inputRef.current.value
    }

    const setFIAT = () => {
        setActive("FIAT")
        outputRef.current.value = (inputRef.current.value / trxPrice).toFixed(2);
    }

    const handleInput = (e) => {
        if (active === "TRX") {
            outputRef.current.value = e.target.value;
        } else {
            outputRef.current.value = (e.target.value / trxPrice).toFixed(2);
        }

        setInput(e.target.value);
    }


    return (
        <>
            <div className="choice-wrapper">
                <ul className="nav tab-nav tab-nav-btn-bdr-s2 justify-content-center justify-content-sm-between pb-4 pb-sm-5">
                    <li><button onClick={setFIAT} className={active === "FIAT" ? "active" : ""}>Buy with FIAT</button></li>
                    <li className="tab-nav-sap d-none d-sm-block"></li>
                    <li><button onClick={setTRX} className={active === "TRX" ? "active" : ""}>Buy with TRX</button></li>
                </ul>
            </div>
            <div className="col-lg-9 col-sm-12">
                <InvestForm
                    active={active}
                    outputRef={outputRef}
                    inputRef={inputRef}
                    input={input}
                    handleInput={handleInput}
                    onOpenModalLogin={props.onOpenModalLogin}
                />
            </div>

        </>)
}

export default InvestHere;